import { schema } from 'normalizr';

const catalogSystemSchema = new schema.Entity('catalogSystems');
const catalogSubsystemSchema = new schema.Entity('catalogSubsystems');
const catalogInformationSchema = new schema.Entity('catalogInformations');

const templateInformationSchema = new schema.Entity('templateInformations', {
  catalogInformation: catalogInformationSchema,
});

const templateSubsystemSchema = new schema.Entity('templateSubsystems', {
  templateInformations: [templateInformationSchema],
  catalogSubsystem: catalogSubsystemSchema,
});

const templateSystemSchema = new schema.Entity('templateSystems', {
  templateSubsystems: [templateSubsystemSchema],
  catalogSystem: catalogSystemSchema,
});

const templateReportSchema = new schema.Entity('templateReport', {
  templateSystems: [templateSystemSchema],
});

export const TemplateSchema = templateReportSchema;
